import React, { useState } from 'react';

const STORAGE_KEY = 'shuttlr_beta_banner_dismissed_v1';
/** Set to true to show the site-wide beta notice again. */
const LIVE_BETA_BANNER_ENABLED = false;

/**
 * Site-wide “Live Beta Testing” notice. Dismissal persists in localStorage.
 */
const LiveBetaBanner = ({ onOpenFeedback }) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
  };

  if (!LIVE_BETA_BANNER_ENABLED || dismissed) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 border-b border-info/30 bg-info-light px-3 py-2.5 sm:px-6"
    >
      <div className="flex min-w-0 max-w-4xl flex-1 flex-col items-center gap-1 sm:flex-row sm:justify-center sm:gap-3">
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-info-dark">
          <span
            className="h-2 w-2 shrink-0 animate-pulse rounded-full bg-info"
            aria-hidden
          />
          Live Beta Testing
        </span>
        <span className="text-center text-xs text-text-secondary sm:text-left sm:text-sm">
          We&apos;re still shipping improvements — thanks for trying the app and sharing feedback.
        </span>
      </div>
      <div className="flex shrink-0 items-center gap-1 sm:gap-2">
        {typeof onOpenFeedback === 'function' && (
          <button
            type="button"
            onClick={onOpenFeedback}
            className="rounded-md px-2 py-1 text-xs font-semibold text-info-dark underline-offset-2 transition-colors hover:bg-surface hover:underline"
          >
            Send feedback
          </button>
        )}
        <button
          type="button"
          onClick={handleDismiss}
          className="rounded-md px-2 py-1 text-xs font-semibold text-text-secondary transition-colors hover:bg-surface hover:text-text-primary"
          aria-label="Dismiss beta testing notice"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default LiveBetaBanner;
